module.exports = __webpack_public_path__ + "static/media/logo-union-europeenne.753291ab.png";